// extracted by mini-css-extract-plugin
module.exports = {"chat_page":"ChatPage_chat_page__Lf6iN"};